import { BrowserModule } from '@angular/platform-browser';
import { NgModule,ErrorHandler,APP_INITIALIZER  } from '@angular/core';
import { Router } from "@angular/router";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PinModule } from './pin/pin.module';
import { GameModule } from './game/game.module';
import { LandingModule } from './landing/landing.module';
import { CheckoutModule } from './checkout/checkout.module';
import { PurchaseSuccessModule } from './purchase-success/purchase-success.module';
import { QuestionModalModule } from './components/questionModal/questionModal.module';
import { EndGameModule } from './endGame/endGame.module';
import { WalkthroughModule } from './components/walkthrough/walkthrough.module';
import { WalkthroughModalModule } from './components/walkthroughModal/walkthroughModal.module';
import { PurchaseErrorModule } from './purchase-error/purchase-error.module';
import { PaymentModule } from './payment/payment.module';
import { MuseumLandingModule } from './museum-landing/museum-landing.module';
import { MuseumOnboardingModule } from './museum-onboarding/museum-onboarding.module';
import { MuseumWalkthroughModule } from './museum-walkthrough/museum-walkthrough.module';
import { MuseumPurchaseComponent } from './museum-purchase/museum-purchase.component';
import { MuseumPurchaseModule } from './museum-purchase/museum-purchase.module';
import { MuseumLeaderboardModule } from './museum-leaderboard/museum-leaderboard.module';
import * as Sentry from "@sentry/angular";
import { MuseumsComponent } from './museums/museums.component';
import { MuseumsModule } from './museums/museums.module';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { StartScreenModule } from './start-screen/start-screen.module';
import { EndScreenModule } from './end-screen/end-screen.module';
import { TouristModule } from './tourist/tourist.module';
import { MuseumGamepassModule } from './museum-gamepass/museum-gamepass.module';
import { ShowcaseModule } from './showcase/showcase.module';
import { TouristSuccessModule } from './touristSuccess/touristSuccess.module';
import { MuseumDirectModule } from './museum-direct/museum-direct.module';
import { ReviewModule } from './review/review.module';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { HelpModule } from './help/help.module';
import { HelloModule } from './hello/hello.module';
@NgModule({
  declarations: [
    AppComponent,
    OnboardingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PinModule,
    GameModule,
    LandingModule,
    CheckoutModule,
    HelpModule,
    HelloModule,
    PurchaseSuccessModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    QuestionModalModule,
    EndGameModule,
    ReviewModule,
    PaymentModule,
    WalkthroughModule,
    WalkthroughModalModule,
    PurchaseErrorModule,
    MuseumsModule,
    MuseumLandingModule,
    MuseumOnboardingModule,
    MuseumGamepassModule,
    MuseumDirectModule,
    TouristSuccessModule,
    ShowcaseModule,
    MuseumWalkthroughModule,
    MuseumPurchaseModule,
    MuseumLeaderboardModule,
    StartScreenModule,
    EndScreenModule,
    TouristModule,
    ReviewModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
